module.exports = __webpack_public_path__ + "img/lab.08f99d6b.jpg";